const url = 'events'
export default server => ({
    async post() {
        let {data} = await server.post(url);
        return data;
    },
    /*async post(fields) {
        let {data} = await server.post(url, fields);
        return data;
    },*/

    async patch(id, fields) {
        let {data} = await server.patch(`${url}/${id}`, fields);
        return data;
    },

    async get(id) {
        let {data} = await server.get(`${url}/${id}`);
        return data;
    },

    async publish(id) {
        return this.patch(id, {'publish': true})
    },
    async remove(id) {
        let {data} = await server.delete(`${url}/${id}`);
        return data;
    },
    async all_active() {
        let {data} = await server.get(`${url}/active`);
        return data;
    },
    async paginate(page = 1, queryStr = '') {
        let {data} = await server.get(`${url}?page=${page}&${queryStr}`);
        return data;
    },
    async removeCoupon(event_id, coupon_id) {
        const {data: {coupon}} = await server.delete(`${url}/${event_id}/coupons/${coupon_id}`);
        return coupon;
    },
    async postCoupon(event_id, code, discount) {
        const {data: {coupon}} = await server.post(`${url}/${event_id}/coupons`, {code, discount});
        return coupon;
    },
    async postQuestion(event_id, form) {
        let {data} = await server.post(`${url}/${event_id}/questions`, form);
        return data;
    },
    async updateQuestion(event_id, question_id, form) {
        let {data} = await server.patch(`${url}/${event_id}/questions/${question_id}`, form);
        return data;
    },
    async removeQuestion(event_id, id) {
        return await server.delete(`${url}/${event_id}/questions/${id}`);
    },
});